import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 8,
    border: '1px solid #e8eaf6',
    boxShadow: 'none',
  },
  content: {
    padding: '20px 24px',
    '&:last-child': {
      paddingBottom: '20px',
    },
  },
}));

/**
 * SettingsCard — flat card used on Settings pages.
 *
 * Visual contract:
 *  - border-radius: 8px
 *  - border: 1px solid #e8eaf6
 *  - padding: 20px 24px
 *  - no drop shadow / no elevation
 *
 * Headerless by design; render a section title above the card if needed.
 */
const SettingsCard = ({ children, className, ...rest }) => {
  const classes = useStyles();
  return (
    <Card elevation={0} className={`${classes.root} ${className || ''}`.trim()} {...rest}>
      <CardContent className={classes.content}>{children}</CardContent>
    </Card>
  );
};

export default SettingsCard;
